import { useState } from "react";
import { GET_DETAIL_STUDENT, GET_ENROLLMENT_PROCESS, Request2Estes } from "./APIs";

const GET_DETAIL_STUDENT_DATA = async (studentid) => {
    const param = { studentid: studentid.toString() };
    const [student_data, student_cpdp ] = await Promise.all([
        GET_DETAIL_STUDENT(param),
        GET_CPDP_POINT(param)
    ]);
    console.log(student_data);
    console.log(student_cpdp);
    if (student_data.data && Object.values(student_data.data).length > 0) {
        if (student_cpdp.message) {
            const combined_data = { ...student_data.data, type_student:1, cpdp_point: 0 };
            return combined_data;
        } else {
            const combined_data = { ...student_data.data, type_student:1, cpdp_point: student_cpdp.data };
            return combined_data;
        }
    }else{
        const param = {candidate_id:studentid.toString()};
        const result = await GET_ENROLLMENT_PROCESS(param);
        console.log("enroll",result);
        if(result.data && Object.values(result.data).length > 0){
            const find_by_candidate = result.data.find(item =>item.candidate_id = param.candidate_id)
            const combined_data = {...find_by_candidate, type_student:2, cpdp_point: 0}
            return combined_data;
        }else{
            return "";
        }
        
    }

}

const GET_CPDP_POINT = async (param) => {
    const param_post = {
        parameters: param,
        target_data: "GET_CPDP_POINT",
    };
    const results = await Request2Estes(param_post);
    if (results.data && Object.values(results.data).length > 0) {
        const find_data = results.data.dt.find(
            (item) => item.studentid === param?.studentid
        );
        return { loading: false, data: find_data?.points || 0, message: "" }
    } else {
        return results;
    }
};

export { GET_DETAIL_STUDENT_DATA }